import occInstance from '@/api/instances/occ.js';
import {ApiDefaults} from '@/constants/api';
import store from '@/store';

const CmsApi = {
  /**
   * Get a component by id.
   * @param {String} userId
   * @param {String} id
   * @param {String} productCode
   * @returns
   */
  async getComponentById(userId, id) {
    const productCodeParam =
      store.state['productDetails']?.product?.code ?? store.state['familyDetails']?.selectedModelId ?? '';
    const params = {
      ...(productCodeParam && {productCode: productCodeParam}),
    };
    const response = await occInstance.get(`/users/${userId}/cms/components/${id}`, {params});
    return response.data;
  },
  /**
   * Get multiple components by an array of component string ids.
   * @param {String} userId
   * @param {Object} params
   * @returns
   */
  async getComponents(userId, {componentIds = [], fields = ApiDefaults.DEFAULT, sort = ''} = {}) {
    const productCodeParam =
      store.state['productDetails']?.product?.code ?? store.state['familyDetails']?.selectedModelId ?? '';
    const params = {
      componentIds,
      fields,
      ...(sort && {sort}),
      ...(productCodeParam && {productCode: productCodeParam}),
    };
    const response = await occInstance.get(`/users/${userId}/cms/components`, {
      params,
      paramsSerializer: {indexes: null},
    });
    return response.data;
  },
  async getPageById(userId, id, params) {
    const response = await occInstance.get(`/users/${userId}/cms/pages/${id}`, {params});
    return response.data;
  },
  async getComponentsByIds(userId = '', componentIds = []) {
    try {
      const componentData = (await this.getComponents(userId, {componentIds})).component;
      //Map component data back to id list to maintain sort order of the id list
      //filter to remove undefined results
      return componentIds.map((id) => componentData.find((cd) => cd.uid === id)).filter((c) => c);
    } catch (err) {
      console.error('Error fetching components...', err);
      return [];
    }
  },
};

export default CmsApi;
